//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Toast } from 'src/index';

export default {
  data() {
    return {
      minHour: 10,
      maxHour: 20,
      minDate: new Date(),
      maxDate: new Date(2019, 10, 1),
      currentDate1: new Date(2018, 0, 1),
      currentDate2: "2017-12-31",
      currentDate3: null
    };
  },

  methods: {
    open(picker) {
      this.$refs[picker].open();
    },

    handleChange(value) {
      Toast({
        message: '已选择 ' + value.toString(),
        position: 'bottom'
      });
    },

    cancel(val){
      console.log(val);
      Toast({
        message: '取消',
        position: 'bottom'
      });
    }

  }
};



// WEBPACK FOOTER //
// ./example/pages/datetime-picker.vue